import { useSession } from "@outschool/ui-auth";
import { useExperiment } from "@outschool/ui-experiments";
import { Screen } from "@outschool/ui-utils";
import { useEffect, useMemo } from "react";

const EXPERIMENT_NAME = "TutoringCLPFiltersMobile";

export default function useTutoringCLPFiltersMobileExperiment() {
  const { currentUserHasLoaded } = useSession();
  const isMobile = Screen.useIsMobile();

  const { variant, trigger } = useExperiment({
    currentUserHasLoaded,
    experimentName: EXPERIMENT_NAME,
  });

  useEffect(() => {
    if (isMobile) {
      trigger();
    }
  }, [trigger, isMobile]);

  return useMemo(
    () => isMobile && variant === "treatment",
    [variant, isMobile]
  );
}
